"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var EffectValue_1 = require("./EffectValue");
var SliderEffectValue = (function (_super) {
    tslib_1.__extends(SliderEffectValue, _super);
    function SliderEffectValue(rawData, version) {
        return _super.call(this, EffectValue_1.EffectValueType.Slider, rawData, version) || this;
    }
    return SliderEffectValue;
}(EffectValue_1.EffectValue));
exports.SliderEffectValue = SliderEffectValue;
//# sourceMappingURL=SliderEffectValue.js.map